import { isEmpty } from "lodash";

export const getCreateRouteManifestRequests = (data, clientId) => {
  const keys = Object.keys(data);
  const routes = [];
  for (let i = 5; i < keys.length; i++) {
    const value = data[keys[i]];
    if (!isEmpty(value))
      routes.push({
        zoneId: value,
      });
  }

  const teams = data?.["teams"]?.split(",")?.map((team) => ({
    teamId: team.trim(),
    clientId: clientId,
  }));

  const vehicleModels = data?.["vehicleModel"]
    ?.split(",")
    ?.map((vehicleModelId) => vehicleModelId.trim());
  const operators = vehicleModels?.map((vehicleModel) => ({
    clientId,
    id: vehicleModel,
    name: vehicleModel,
  }));

  return {
    clientId: clientId,
    id: data?.id,
    name: data?.name,
    code: data?.id,
    status: "ACTIVE",
    description: data?.["regionTypes/0"],
    operatorType: "VEHICLE_MODEL",
    operators,
    route: routes,
    teams: teams,
  };
};
